package com.anjuros.website.redesign.sections.home

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdEyebrow
import com.anjuros.website.redesign.components.RdGhostButton
import com.anjuros.website.redesign.components.RdLede
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.HomeBandStyle
import com.anjuros.website.redesign.styles.HomeOfferStyle
import com.anjuros.website.redesign.styles.HomePortalGridStyle
import com.anjuros.website.redesign.styles.HomePortalImageStyle
import com.anjuros.website.redesign.styles.HomeStackStyle
import com.anjuros.website.redesign.styles.HomeTicksStyle
import com.anjuros.website.redesign.styles.RdGhostButtonOnDarkStyle
import com.anjuros.website.redesign.styles.RdH2Style
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

private val PortalTicks = listOf(
    RdText.HOME_PORTAL_TICK1,
    RdText.HOME_PORTAL_TICK2,
    RdText.HOME_PORTAL_TICK3,
    RdText.HOME_PORTAL_TICK4,
    RdText.HOME_PORTAL_TICK5,
)

/** Dark band promoting the Job Management Portal. */
@Composable
fun HomePortalSection() {
    RdSection(
        id = "portal",
        labelledBy = "portal-h",
        modifier = RdSectionStyle.toModifier().then(HomeBandStyle.toModifier()),
        wrapModifier = HomePortalGridStyle.toModifier(),
    ) {
        Div(HomeStackStyle.toModifier().toAttrs()) {
            RdEyebrow(RdText.HOME_PORTAL_EYEBROW)
            H2(RdH2Style.toModifier().id("portal-h").toAttrs()) { Text(LocalText(RdText.HOME_PORTAL_TITLE)) }
            RdLede(RdText.HOME_PORTAL_LEDE)
            Ul(HomeTicksStyle.toModifier().toAttrs()) {
                PortalTicks.forEach { Li { Text(LocalText(it)) } }
            }
            P(HomeOfferStyle.toModifier().toAttrs()) {
                B { Text(LocalText(RdText.HOME_PORTAL_OFFER_BOLD)) }
                Text(LocalText(RdText.HOME_PORTAL_OFFER_TEXT))
            }
            Div {
                RdGhostButton(RdRoute.PORTAL, RdText.HOME_PORTAL_EXPLORE, withArrow = true, modifier = RdGhostButtonOnDarkStyle.toModifier())
            }
        }
        Div(HomePortalImageStyle.toModifier().toAttrs()) {
            RdPicture(RdImage.PORTAL_DESKTOP, LocalText(RdText.HOME_PORTAL_IMAGE_ALT))
        }
    }
}
